<!-- =========================================================================================
    File Name: VxSidebar.vue
    Description: Sidebar Component
    Component Name: VxSidebar
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template lang="html">
  <div class="parentx">
    <vs-sidebar ref="mainSidebar" :parent="parent" :hiddenBackground="true" :reduce="reduce" default-index="-1"
                class="sidebarx main-menu-sidebar items-no-padding"
                :class="[{'main-menu-sidebar_active': isMouseEnter}]" v-model="isSidebarActive"
                :click-not-close="clickNotClose" :reduce-not-rebound="reduceNotRebound">
      <div @mouseenter="sidebarMouseEntered" @mouseleave="sidebarMouseLeave" style="margin: 0 -15px; padding: 0 15px"
           class="flex flex-col h-full">
        <div class="header-sidebar flex items-end justify-between items-center flex-shrink-0" slot="header"
             style="height: 85px; padding: 0;">
          <router-link to="/" class="mx-auto">
            <img :src="logo" alt="ELSA" style="width: 190px;" v-show="(isMouseEnter || !reduce)">
            <img :src="logoMin" alt="ELSA" v-show="!(isMouseEnter || !reduce)" style="width: 50px">
          </router-link>
          <template v-if="showCloseButton">
            <feather-icon icon="XIcon" class="m-0 cursor-pointer"
                          @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)" />
          </template>
          <template v-else-if="!showCloseButton && !sidebarItemsMin">
            <feather-icon icon="DiscIcon" class="mr-0 cursor-pointer" svg-classes="stroke-current" v-show="!reduce"
                          @click="toggleReduce(true)" id="btnSidebarToggler" />
            <feather-icon icon="CircleIcon" class="mr-0 cursor-pointer" svg-classes="stroke-current" v-show="reduce"
                          @click="toggleReduce(false)" id="btnSidebarToggler" />
          </template>
        </div>

<!--        <template v-if="$acl.check('isEmployee')">-->
<!--          <div class="employee-user-settings" v-show="(isMouseEnter || !reduce)">-->
<!--            <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">-->
<!--              <p class="font-semibold text-lg whitespace-normal">{{ username }}</p>-->
<!--              <vs-dropdown-menu ref="profileDropdownMenu">-->
<!--                <ul style="min-width: 9rem">-->
<!--                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout()">-->
<!--                    <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />-->
<!--                    <span class="ml-2">Выйти</span></li>-->
<!--                </ul>-->
<!--              </vs-dropdown-menu>-->
<!--            </vs-dropdown>-->

<!--            <div class="employee-user-settings__settings-button link-icon" @click="openAppSettings">-->
<!--              <app-icon name="SettingsIcon" size="18px" />-->
<!--            </div>-->
<!--          </div>-->

<!--          <the-house-select v-show="(isMouseEnter || !reduce)" />-->

<!--          &lt;!&ndash;                    <div v-show="(isMouseEnter || !reduce) && false" class="mb-0 text-center">&ndash;&gt;-->

<!--          &lt;!&ndash;                        <vs-dropdown vs-custom-content vs-trigger-click vs-drop-right divider class="cursor-pointer whitespace-normal w-full" @mouseenter="sidebarMouseEntered">&ndash;&gt;-->
<!--          &lt;!&ndash;                            <span class="cursor-pointer flex i18n-locale justify-center">&ndash;&gt;-->
<!--          &lt;!&ndash;                                <u>{{house.address}}</u>&ndash;&gt;-->
<!--          &lt;!&ndash;                            </span>&ndash;&gt;-->

<!--          &lt;!&ndash;                            <vs-dropdown-menu v-show="houses.length > 0" ref="housesDropdownMenu">&ndash;&gt;-->
<!--          &lt;!&ndash;                                <vs-dropdown-item   v-for="houseLocal in houses" :key="`house${houseLocal.id}`" @click="house = houseLocal" style="border-radius: 0; border-bottom: 1px solid #eee;">{{houseLocal.address}}</vs-dropdown-item>&ndash;&gt;-->
<!--          &lt;!&ndash;                            </vs-dropdown-menu>&ndash;&gt;-->
<!--          &lt;!&ndash;                        </vs-dropdown>&ndash;&gt;-->
<!--          &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--        </template>-->

        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar pt-2" :settings="settings"
                             @ps-scroll-y="psSectionScroll">
          <template v-for="(sidebarItem, index) in sidebarItems">
            <div v-if="canShowItem(sidebarItem)" :key="'sidebarItem' + index">
              <!-- GROUP ITEM HEADER -->
              <span :key="`header-${index}`" v-if="sidebarItem.header && !sidebarItemsMin"
                    class="navigation-header truncate mt-4">{{ sidebarItem.header }}</span>
              <template v-else-if="!sidebarItem.header">

                <!-- IF IT'S SINGLE ITEM -->
                <vx-sidebar-item ref="sidebarLink" :key="`sidebarItem-${index}`"
                                 v-if="!sidebarItem.submenu && sidebarItem.url" :index="index"
                                 :to="sidebarItem.slug != 'external' ? sidebarItem.url : ''"
                                 :href="sidebarItem.slug == 'external' ? sidebarItem.url : ''" :icon="sidebarItem.icon"
                                 :target="sidebarItem.target"
                                 :isDisabled="sidebarItem.isDisabled || (typeUser === 3 && !allAparts.length)">
                  <span v-show="!sidebarItemsMin" class="truncate"
                        :title="sidebarItem.name">{{ sidebarItem.name }}</span>
                  <vs-chip class="ml-auto" :color="sidebarItem.tagColor"
                           v-if="sidebarItem.tag && (isMouseEnter || !reduce)">{{ sidebarItem.tag }}
                  </vs-chip>
                </vx-sidebar-item>

                <!-- IF HAVE SUBMENU / DROPDOWN -->
                <template v-else-if="sidebarItem.submenu">
                  <vx-sidebar-group ref="sidebarGrp" :key="`group-${index}`" :openHover="openGroupHover"
                                    :group="sidebarItem" :groupIndex="index"
                                    :open="isGroupActive(sidebarItem)" />
                </template>
              </template>
            </div>
          </template>
        </VuePerfectScrollbar>

        <the-sidebar-footer v-if="$acl.check('isEmployee') && (isMouseEnter || !reduce)" />
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VxSidebarGroup      from './VxSidebarGroup.vue';
import VxSidebarItem       from './VxSidebarItem.vue';

import { mapGetters }   from 'vuex';
import TheSidebarFooter from "../TheSidebarFooter";
import $can             from "@/utils/abilities";
// import TheHouseSelect   from "../the-house-select/TheHouseSelect";

export default {
  name:       'vx-sidebar',
  props:      {
    sidebarItems:     {
      type:     Array,
      required: true,
    },
    title:            {
      type: String,
    },
    logo:             {
      type: String,
    },
    logoMin:          {
      type: String,
    },
    parent:           {
      type: String,
    },
    openGroupHover:   {
      type:    Boolean,
      default: false,
    },
    reduceNotRebound: {
      type:    Boolean,
      default: true,
    },
  },
  data:       () => ({
    clickNotClose:    false, // disable close sidebar on outside click
    reduce:           false, // determines if sidebar is reduce - component property
    showCloseButton:  false, // show close button in smaller devices
    isMouseEnter:     false,
    settings:         { // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed:         1,
      swipeEasing:        true,
    },
    windowWidth:      window.innerWidth, //width of windows
    showShadowBottom: false,
  }),
  computed:   {
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set( val ) {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', val);
      },
    },
    reduceSidebar() {
      return Boolean(this.reduce && this.reduceButton);
    },
    reduceButton:    {
      get() {
        return this.$store.state.reduceButton;
      },
      set( val ) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val);
      },
    },
    sidebarItemsMin() {
      return this.$store.state.sidebarItemsMin;
    },
    isGroupActive() {
      return ( sidebarItem ) => {
        const path = this.$route.fullPath;
        let open = false;
        let func = function ( sidebarItem ) {
          if (sidebarItem.submenu) {
            sidebarItem.submenu.forEach(( item ) => {
              if (path == item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(sidebarItem);
        return open;
      };
    },
    ...mapGetters('appUser', {
      typeUser:  'type',
      allAparts: 'allAparts',
      apart:     'apart',
      username:  'name',
      houses:    'houses',
    }),
    house:           {
      get() {
        return this.$store.getters['appUser/selectedHouse'];
      },
      set( value ) {
        this.$store.dispatch('appUser/UPDATE_SELECTED_HOUSE', value);
      },
    },
  },
  watch:      {

    sidebarItems: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
    reduce( val ) {

      if (val == true) {
        this.$store.dispatch('updateSidebarWidth', 'reduced');

      } else {
        this.$store.dispatch('updateSidebarWidth', 'default');
      }

      // setTimeout(function(){
      //     window.dispatchEvent(new Event('resize'));
      // }, 100);
    },
    reduceButton() {
      this.setSidebarWidth();
    },
    '$route'() {
      if (this.isSidebarActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
    },
  },
  methods:    {
    openAppSettings() {
      this.$emit('open-app-settings');
    },
    canShowItem( item ) {
      let canShow = true;
      let abilitiesRule = item.abilitiesRule ? item.abilitiesRule : 'access';
      canShow = canShow && this.$acl.check(item.user);

      if (item.slug === 'client_issues' && (this.apart && Number(this.apart.address[0].id) === 36)) {
        return false;
      }

      if (item.abilities) {
        canShow = canShow && $can(item.abilities, abilitiesRule, undefined, item.users, item.mcsIds);
      }

      return canShow;
    },
    async logout() {
      await this.$store.dispatch('appUser/LOGOUT');
    },
    sidebarMouseEntered() {
      if (this.reduce) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false);
      this.isMouseEnter = true;
    },
    sidebarMouseLeave() {
      if (this.reduce) {
        this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true);
      }
      this.isMouseEnter = false;
    },
    toggleReduce( val ) {
      this.reduceButton = val;
      localStorage.setItem("isSidebarMin", val);
      this.setSidebarWidth();
    },
    handleWindowResize( event ) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        if (this.windowWidth < 992) this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'md');
        else this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'lg');

        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
        if (this.reduceButton) this.reduce = false;
        // this.reduceButton = false;
        this.showCloseButton = true;
        this.clickNotClose = false;
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar');
        this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false);
      } else {
        this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'xl');
        if (this.reduceButton) this.reduce = true;
        else this.reduce = false;

        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
        if (this.reduceButton && !this.isMouseEnter) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true);
        else this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false);

        this.clickNotClose = true;
        this.showCloseButton = false;
        if (this.reduceSidebar)
          this.$store.dispatch('updateSidebarWidth', 'reduced');
        else
          this.$store.dispatch('updateSidebarWidth', 'default');
      }
    },
    psSectionScroll() {
      if (this.$refs.mainSidebarPs.$el.scrollTop > 0) this.showShadowBottom = true;
      else this.showShadowBottom = false;
    },
  },
  components: {
    TheSidebarFooter,
    VxSidebarGroup,
    VxSidebarItem,
    VuePerfectScrollbar,
    // TheHouseSelect,
  },
  mounted() {
    let isSidebarMin = localStorage.getItem("isSidebarMin") === 'true';
    this.toggleReduce(isSidebarMin);
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);

      let cloneFunc = function ( funct ) {
        var that = funct;
        var temp = function temporary() {
          return that.apply(this, arguments);
        };
        for (var key in this) {
          if (this.hasOwnProperty(key)) {
            temp[key] = this[key];
          }
        }
        return temp;
      };

      // if (this.$acl.check('isEmployee')) {
      //   // let housesDropdownMenuMouseEnterFunction = cloneFunc(this.$refs.housesDropdownMenu.mouseenterx);
      //   // let housesDropdownMenuMouseLeaveFunction = cloneFunc(this.$refs.housesDropdownMenu.mouseleavex);
      //   // this.$refs.housesDropdownMenu.mouseenterx = () => {this.sidebarMouseEntered(); housesDropdownMenuMouseEnterFunction()};
      //   // this.$refs.housesDropdownMenu.mouseleavex = () => {this.sidebarMouseLeave(); housesDropdownMenuMouseLeaveFunction()};
      //
      //   let profileDropdownMenuMouseEnterFunction = cloneFunc(this.$refs.profileDropdownMenu.mouseenterx);
      //   let profileDropdownMenuMouseLeaveFunction = cloneFunc(this.$refs.profileDropdownMenu.mouseleavex);
      //   this.$refs.profileDropdownMenu.mouseenterx = () => {
      //     this.sidebarMouseEntered();
      //     profileDropdownMenuMouseEnterFunction();
      //   };
      //   this.$refs.profileDropdownMenu.mouseleavex = () => {
      //     this.sidebarMouseLeave();
      //     profileDropdownMenuMouseLeaveFunction();
      //   };
      // }


    });
    this.setSidebarWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebar.scss";

.employee-user-settings {
  position: relative;
  margin: .5rem -15px;
  padding: 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;

  &__settings-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }


}

</style>
